function pathOnly(path: string): string {
  return path.split('?')[0].split('#')[0];
}

export const KNOW_LOGIN_PATH = '/login';
export const SUPPORT_PATH = '/support';

export function tenantHasAnyLicensedModule(moduleCodes?: string[] | null): boolean {
  if (!moduleCodes) {
    return true;
  }

  return moduleCodes.length > 0;
}

export function resolveLoginRouteForTenant(
  _moduleCodes?: string[] | null,
  _defaultProductModuleCode?: string | null,
): string {
  return KNOW_LOGIN_PATH;
}

const PUBLIC_PATH_ALLOWLIST = [
  SUPPORT_PATH,
  '/documents/public',
  '/forms/public',
  '/csat/',
  '/validate',
  '/sign/',
  '/forgot-password',
] as const;

export function isTenantSupportExemptPath(pathname: string): boolean {
  const normalized = pathOnly(pathname).toLowerCase();

  for (const allowed of PUBLIC_PATH_ALLOWLIST) {
    if (normalized === allowed || normalized.startsWith(allowed)) {
      return true;
    }
  }

  return false;
}

const POST_LOGIN_EXCLUDED_PATH_PREFIXES = [
  '/validate',
  '/login',
  '/forgot-password',
  '/documents/public',
] as const;

export function isPostLoginRedirectExcluded(path: string): boolean {
  const normalized = pathOnly(path).toLowerCase();
  if (!normalized.startsWith('/')) {
    return true;
  }

  for (const prefix of POST_LOGIN_EXCLUDED_PATH_PREFIXES) {
    if (normalized === prefix || normalized.startsWith(`${prefix}/`)) {
      return true;
    }
  }

  if (/^\/sign\/[^/]+$/i.test(normalized) && normalized !== '/sign/inbox') {
    return true;
  }

  return false;
}

export interface PostLoginUserContext {
  isAdmin?: boolean;
  roleCode?: string;
}

export function resolveHomePageForUser(ctx: PostLoginUserContext | null): string {
  if (!ctx) {
    return '/home';
  }

  const userRole = (ctx.roleCode ?? '').toLowerCase();

  if (ctx.isAdmin || userRole === 'manager' || userRole === 'editor') {
    return '/home';
  }

  if (userRole === 'user') {
    return '/sign/inbox';
  }

  if (userRole === 'viewer') {
    return '/copilot';
  }

  return '/home';
}
